import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-893d8a1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "command-actions" }
const _hoisted_2 = { class: "command-settings" }
const _hoisted_3 = { class: "subtitle" }
const _hoisted_4 = { class: "subtitle" }

import {computed, ref} from "vue";
import {CommandSettings} from "@/types/CommandSettings";
import SelectItems from "@/utils/SelectItems";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import {Guild} from "@/types/Guild";
import config from "@/config.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildCommand',
  props: {
    name: {},
    command: {}
  },
  emits: ['update'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const route = useRoute()
const store = useStore()
let guild = computed(() => (store.getters.guilds as Array<Guild>).find(g => g.id === route.params.id));
let roles = SelectItems.roles(guild.value!.roles!, false, false)
let channels = SelectItems.channels(guild.value!.channels!, false, false)
let permsList = ['allowedRoles', 'forbiddenRoles', 'allowedChannels', 'forbiddenChannels']
let dialog = ref(false)
let loading = ref(false)

async function submit() {
  loading.value = true;
  let response = await fetch(`${config.API}/private/guilds/${route.params.id}/commands/${props.command.name}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token') as string
    },
    body: JSON.stringify(props.command)
  })
  loading.value = false;
  dialog.value = false
  if (response.ok) emit('update', 'success', response.status, props.command)
  else emit('update', 'error', response.status)
}

return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_switch, {
        modelValue: _ctx.command.enabled,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.command.enabled) = $event)),
        class: "command-enable",
        color: "primary",
        loading: _unref(loading),
        disabled: _unref(loading),
        "hide-details": "",
        onChange: submit
      }, null, 8, ["modelValue", "loading", "disabled"]),
      _createVNode(_component_v_btn, {
        icon: "",
        variant: "text",
        size: "small",
        disabled: !_ctx.command.enabled || _unref(loading),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(dialog) //@ts-ignore
 ? dialog.value = !_unref(dialog) : dialog = !_unref(dialog)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { size: "25" }, {
            default: _withCtx(() => [
              _createTextVNode("settings")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _unref(dialog),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(dialog) ? (dialog).value = $event : dialog = $event)),
      fullscreen: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { color: "modal" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar, {
              dark: "",
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  icon: "",
                  disabled: _unref(loading),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(dialog) //@ts-ignore
 ? dialog.value = false : dialog = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_toolbar_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_toolbar_items, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      dark: "",
                      text: "",
                      loading: _unref(loading),
                      onClick: submit
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "btn-icon",
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("save")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('GuildModeration.submit')), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_form, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('GuildCommands.subtitles.general')), 1),
                  _createVNode(_component_v_checkbox, {
                    modelValue: _ctx.command.deleteUsage,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.command.deleteUsage) = $event)),
                    color: "primary",
                    "hide-details": "",
                    label: _ctx.$t('GuildCommands.subtitles.deleteUsage')
                  }, null, 8, ["modelValue", "label"]),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('GuildCommands.subtitles.permissions')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(permsList), (perm) => {
                    return (_openBlock(), _createBlock(_component_v_select, {
                      modelValue: _ctx.command[perm],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.command[perm]) = $event),
                      class: "perms-select mb-2",
                      multiple: "",
                      chips: "",
                      "closable-chips": "",
                      label: _ctx.$t(`GuildCommands.permissionsLabel.${perm}`),
                      hint: _ctx.$t(`GuildCommands.permissionsHint.${perm}`),
                      "persistent-hint": "",
                      items: perm.includes('Roles') ? _unref(roles) : _unref(channels)
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "hint", "items"]))
                  }), 256))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})